import { cn } from '@helios/ui';
import './construction-os-logo.css';

type ConstructionOsLogoVariant = 'auth' | 'corner' | 'sidebar' | 'compact' | 'mobile' | 'toolbar' | 'sidebar-toolbar';

interface ConstructionOsLogoProps {
  className?: string;
  variant: ConstructionOsLogoVariant;
}

const logoSources = {
  auth: {
    src: '/brand/helios-construction-os-lockup.png',
    width: 900,
    height: 995,
  },
  corner: {
    src: '/brand/helios-construction-os-lockup.png',
    width: 900,
    height: 995,
  },
  sidebar: {
    src: '/brand/helios-construction-os-lockup.png',
    width: 900,
    height: 995,
  },
  compact: {
    src: '/brand/helios-construction-os-mark.png',
    width: 430,
    height: 790,
  },
  mobile: {
    src: '/brand/helios-construction-os-lockup.png',
    width: 900,
    height: 995,
  },
  toolbar: {
    src: '/brand/helios-construction-os-mark.png',
    width: 430,
    height: 790,
  },
  'sidebar-toolbar': {
    src: '/brand/helios-construction-os-mark.png',
    width: 430,
    height: 790,
  },
} as const;

export function ConstructionOsLogo({
  className,
  variant,
}: ConstructionOsLogoProps) {
  const source = logoSources[variant];

  return (
    <span
      className={cn(
        'construction-os-logo',
        `construction-os-logo--${variant}`,
        className,
      )}
    >
      <img
        className="construction-os-logo__image"
        src={source.src}
        alt="HELIOS Construction OS"
        width={source.width}
        height={source.height}
        draggable={false}
      />
    </span>
  );
}
